var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { AccordionItem } from "@irati/ui/src/Accordion";
import { injectIntl } from "@irati/utils/lang";
import FeaturesContent from "./FeaturesContent";
var AppFeatures = /** @class */ (function (_super) {
    __extends(AppFeatures, _super);
    function AppFeatures() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appFeaturesAccordion = React.createRef();
        _this.toggleAccordion = function () {
            var shouldOpen = !_this.appFeaturesAccordion.current.state.isExpanded;
            if (shouldOpen) {
                _this.appFeaturesAccordion.current.open();
            }
            else {
                _this.appFeaturesAccordion.current.close();
            }
        };
        return _this;
    }
    AppFeatures.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, isMobile = _a.isMobile;
        if (isMobile) {
            return (React.createElement("div", { onClick: function () { return _this.toggleAccordion(); } },
                React.createElement(AccordionItem, { ref: this.appFeaturesAccordion, title: formatMessage({ id: "medical.activation.appFeatures.title" }) },
                    React.createElement(FeaturesContent, null))));
        }
        return React.createElement(FeaturesContent, null);
    };
    return AppFeatures;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.medium
    });
};
export default injectIntl(connect(mapStateToProps)(AppFeatures));
